import { useState } from "react";
import { Expandable } from "render/ui/presentation/Expandable";
import { Typography } from "render/ui/presentation/Typography";
import { ReactComponent as CrossIcon } from "./assets/cross.svg";
import styles from "./styles.module.sass";

interface AccordionProps {
  header: JSX.Element | string;
  text: JSX.Element | string;
}

export function Accordion({ header, text }: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={styles.Accordion}>
      <div className={styles.header} onClick={() => setIsOpen((v) => !v)}>
        <Typography variant="body-m">{header}</Typography>
        <CrossIcon className={styles.icon} data-open={isOpen} />
      </div>
      <Expandable isOpen={isOpen}>
        <div className={styles.content}>{text}</div>
      </Expandable>
    </div>
  );
}
